import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    accessToken: null,
    refreshToken: null,
    tokenType: 'Bearer',
    expiresAt: null,
    refreshExpiresAt: null,
    isAuthenticated: false,
    isSessionExpiredByInactivity: false,
};
const tokensSlice = createSlice({
    name: 'tokens',
    initialState,
    reducers: {
        setTokens: (state, action) => {
            const { accessToken, refreshToken, tokenType = 'Bearer', expiresIn, refreshExpiresIn } = action.payload;
            state.accessToken = accessToken;
            state.refreshToken = refreshToken || null;
            state.tokenType = tokenType;
            state.isAuthenticated = true;
            if (expiresIn) {
                state.expiresAt = Date.now() + expiresIn * 1000;
            }
            if (refreshExpiresIn) {
                state.refreshExpiresAt = Date.now() + refreshExpiresIn * 1000;
            }
            state.isSessionExpiredByInactivity = false;
        },
        clearTokens: state => {
            state.accessToken = null;
            state.refreshToken = null;
            state.tokenType = 'Bearer';
            state.expiresAt = null;
            state.refreshExpiresAt = null;
            state.isAuthenticated = false;
            state.isSessionExpiredByInactivity = false;
        },
        updateAccessToken: (state, action) => {
            const { accessToken, expiresIn } = action.payload;
            state.accessToken = accessToken;
            if (expiresIn) {
                state.expiresAt = Date.now() + expiresIn * 1000;
            }
            state.isSessionExpiredByInactivity = false;
        },
        setSessionExpiredByInactivity: state => {
            state.isSessionExpiredByInactivity = true;
        },
        resetSessionExpiredByInactivity: state => {
            state.isSessionExpiredByInactivity = false;
        },
    },
});
export const { setTokens, clearTokens, updateAccessToken, setSessionExpiredByInactivity, resetSessionExpiredByInactivity, } = tokensSlice.actions;
export default tokensSlice.reducer;
